export default {
  path: 'finance',
  name: 'finance',
};
